import { useMemo, useCallback } from 'react';
import { useFlatRoutesStationRecommendations } from './useFlatRoutesStationRecommendations';

import { StationCode } from 'entities/map';

export const useCheckIsRoutesStationRecommendation = () => {
  const flatRoutesStationRecommendations = useFlatRoutesStationRecommendations();

  const routeStationRecommendations = useMemo(() => (
    flatRoutesStationRecommendations.reduce((acc, stationCode) => {
      acc[stationCode] = true;
      return acc;
    }, {} as { [key: StationCode]: boolean; })
  ), [flatRoutesStationRecommendations]);

  const checkIsRoutesStationRecommendation = useCallback((stationCode: StationCode) => !!routeStationRecommendations[stationCode], [routeStationRecommendations]);

  return checkIsRoutesStationRecommendation;
};
